'use client';

interface GlobalErrorProps {
  error: Error & { digest?: string };
  reset: () => void;
}

export default function GlobalError({ reset }: GlobalErrorProps): JSX.Element {
  return (
    <html>
      <body>
        <div style={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontFamily: 'system-ui, sans-serif'
        }}>
          <div style={{ textAlign: 'center', padding: '2rem' }}>
            <h2 style={{ marginBottom: '1rem' }}>Something went wrong</h2>
            <button
              onClick={reset}
              style={{
                padding: '0.5rem 1rem',
                cursor: 'pointer',
                marginRight: '0.5rem'
              }}
            >
              Try again
            </button>
            <button
              onClick={() => window.location.href = '/'}
              style={{ padding: '0.5rem 1rem', cursor: 'pointer' }}
            >
              Go home
            </button>
          </div>
        </div>
      </body>
    </html>
  );
}
